import { Fragment } from 'react'
import classNames from 'classnames'

import { useInitData } from '../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import { renderCell } from './AttachServiceRequestsModalTableRow.utils.js'

import * as styles from './AttachServiceRequestsModalTableRow.module.css'

function AttachServiceRequestsModalTableRow({
  Actions = TableRowActions,
  actionsColumnWidth,
  columns,
  disabled,
  emptyColumnSize,
  extra,
  isSelected,
  item,
  readonly,
  onClick,
  ...restProps
}) {
  const { uuid } = item

  const { availableSections } = useInitData()

  const { handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ ...restProps, item, onClick })

  function handleClick() {
    onClick?.(uuid)
  }

  const rowClass = useTableRowModClassName({
    className: classNames(styles.AttachServiceRequestsModalTableRow, {
      [styles.readonly]: readonly || disabled,
    }),
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={rowClass}
      key={item.id}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          checked={isSelected}
          disabled={!isSelected && disabled}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            availableSections,
            extra,
            item,
            name: column.name,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default AttachServiceRequestsModalTableRow
